"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.issueIs = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const IssueStatus_1 = __importDefault(require("../IssueStatus"));
exports.issueIs = {
    // -----
    // ROOT
    // -----
    new: (issue) => {
        if (!issue)
            return false;
        return issue.status === IssueStatus_1.default.NEW;
    },
    inprogress: (issue) => {
        if (!issue)
            return false;
        return issue.status === IssueStatus_1.default.IN_PROGRESS;
    },
    closed: (issue) => {
        if (!issue)
            return false;
        return issue.status === IssueStatus_1.default.CLOSED;
    },
    // -----
    // BASIC
    // -----
    late: (issue) => {
        if (!issue)
            return false;
        if (!issue.deadlineDate)
            return false;
        if (exports.issueIs.closed(issue))
            return false;
        return (0, moment_timezone_1.default)().isAfter(issue.deadlineDate);
    },
};
exports.default = exports.issueIs;
